import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import React from 'react'
import { Field, ErrorMessage, FieldProps, form } from 'formik'
import TextError from './TextError'
import './Formikcss.css'
function CkEditer(props) {
    const { label, name, ...rest } = props
    return (
        <div>
            <Field name={name} >
                {
                    ({form, field}) => {
                        const { setFieldValue } = form
                        const { value } = field
                     
                        // <CKEditor editor={ClassicEditor} data={addData} onChange={handleChange}/>
                        // return <DateView id={name} {...field} {...rest} selected={value} onChange={val => setFieldValue(name,val)}/>
                        return <CKEditor 
                                    editor={ClassicEditor} 
                                    {...rest} 
                                            onChange={(e,editor) => setFieldValue(name,editor.getData())}  
                                            data={value}

                                />
                    }
                }
            </Field>
            <ErrorMessage name={name} component={TextError}/>
               
        </div>
    )
}

export default CkEditer
